export default "__VITE_ASSET__CHXW4JYZ__"